import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import {
	clientPayout,
	clientProfileList,
} from 'src/app/modules/payout/models/client-payout'
import {
	PaymentPayoutStatus,
	PayoutStatus,
} from 'src/app/modules/payout/models/client-payout.enum'
import { PayoutService } from 'src/app/modules/payout/services/payout.service'

@Component({
	selector: 'app-client-payouts',
	templateUrl: './client-payouts.component.html',
	styleUrls: ['./client-payouts.component.scss'],
})
export class ClientPayoutsComponent implements OnInit {
	@Input() payoutDataTable: clientProfileList[] = []
	@Input() selectedCountry!: number
	@Input() payoutDataFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
	}
	@Input() totalCount = 0
	@Output() actionChanged: EventEmitter<any> = new EventEmitter()
	@Output() flipped = new EventEmitter()
	@Output() payoutStatus = new EventEmitter()
	subscription = new Subscription()
	clientDeatailsData!: clientPayout

	isFlipped = false
	PaymentPayoutStatus = PayoutStatus
	clientId: any
	queryParamsData: any = {
		activeTab: '',
		countryId: '',
		pageNumber: '',
		pageSize: '',
		payoutId: '',
		status: '',
	}
	constructor(
		public translate: TranslateService,
		private routeActivate: ActivatedRoute,
		private router: Router,
		private payoutService: PayoutService
	) {}

	ngOnInit(): void {
		this.routeActivate.params.subscribe(({ id }) => {
			this.clientId = id
			this.subscription.add(
				this.routeActivate.queryParams.subscribe((res) => {
					this.queryParamsData.activeTab = res['activeTab']
					this.queryParamsData.countryId = res['country']
					this.queryParamsData.pageNumber = res['page']
					this.queryParamsData.pageSize = res['count']
					this.queryParamsData.payoutId = res['payoutId']
					this.queryParamsData.status = res['status']
				})
			)
		})
	}
	toggle() {
		if (this.isFlipped) {
			this.flipped.emit(true)
		} else {
			this.flipped.emit(false)
		}
	}
	flipChange(id: any, status: any) {
		this.router.navigate(['/layout/clients/client-profile/' + this.clientId], {
			queryParams: {
				country: this.queryParamsData.countryId,
				activeTab: this.queryParamsData.activeTab,
				page: this.queryParamsData.pageNumber,
				count: this.queryParamsData.pageSize,
				payoutId: id,
				status: status,
			},
		})
	}
	getDetails(id: number) {
		this.subscription.add(
			this.payoutService.getClientPayoutDetails(id).subscribe((res: any) => {
				this.clientDeatailsData = res.result
			})
		)
	}
}
